import { render, staticRenderFns } from "./cancel-trades.vue?vue&type=template&id=1b08e08f&"
import script from "./cancel-trades.vue?vue&type=script&lang=js&"
export * from "./cancel-trades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports